<template>
  <ul class="nav navbar-nav top-nav">
    <li>
      <button
        type="button"
        class="btn theme-toggle"
        :title="isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'"
        :aria-label="isDarkTheme ? 'Switch to light mode' : 'Switch to dark mode'"
        @click="toggleTheme"
      >
        <i :class="isDarkTheme ? 'fa-solid fa-sun' : 'fa-solid fa-moon'"></i>
      </button>
    </li>
    <li v-if="isAdmin && currentTenant !== '' && currentTenant !== 'ezy'">
      <ExportImportSettings />
    </li>
    <li v-if="isAdmin">
      <TenantModifier />
    </li>
    <li class="d-none d-md-block">
      <UserDropdown />
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import TenantModifier from './TenantModifier'
import ExportImportSettings from './ExportImportSettings'
import UserDropdown from './UserDropdown'

export default {
  components: {
    TenantModifier,
    ExportImportSettings,
    UserDropdown
  },
  computed: {
    ...mapGetters([
      'currentTenant',
      'isLoggedIn',
      'isAdmin',
      'isDarkTheme'
    ])
  },
  methods: {
    toggleTheme() {
      this.$store.commit('setTheme', this.isDarkTheme ? 'light' : 'dark')
    }
  }
}
</script>

<style scoped>
.theme-toggle {
  width: 38px;
  height: 38px;
  padding: 0;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.theme-toggle:hover,
.theme-toggle:focus {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.8);
  color: #fff;
}

.navbar-text {
  padding: 10px;
  margin: 10px;
  color: #fff;
}


@media (max-width: 768px) {
  .navbar-text {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainHeader.vue